/*==================================================
  XKIND CUSTOMER REVIEWS
  PART 1 - JSON + Render Cards
==================================================*/

document.addEventListener("DOMContentLoaded", function () {

    const jsonElement = document.getElementById("xk-review-json");
    const container = document.getElementById("xk-review-container");

    if (!jsonElement || !container) return;

let data={};

let reviews=[];

try{

data=JSON.parse(jsonElement.textContent);

reviews=data.reviews || [];

}catch(error){

        console.error("Customer Reviews JSON Error", error);

        return;

    }

    window.xkReviews = reviews;

    function generateStars(rating) {

        rating = parseInt(rating);

        let html = "";

        for (let i = 1; i <= 5; i++) {

            html += i <= rating ? "★" : "☆";

        }

        return html;

    }

    function getInitial(name){

        if(!name) return "A";

        return name.trim().charAt(0).toUpperCase();

    }

    function renderCards(){

        container.innerHTML = "";

        reviews.forEach(function(review,index){

            container.insertAdjacentHTML("beforeend",`

<div class="xk-review-card">

    <div class="xk-review-image">

        ${review.image ?

        `<img src="${review.image}" loading="lazy" alt="${review.name}">`

        :``}

    </div>

    <div class="xk-review-content">

        <div class="xk-user">

            <div class="xk-user-left">

                <div class="xk-avatar">

                    ${getInitial(review.name)}

                </div>

                <div class="xk-user-info">

                    <div class="xk-user-name">

                        ${review.name}

                    </div>

                    <div class="xk-review-date">

                        ${review.date || "2 days ago"}

                    </div>

                    ${review.verified ?

                    `<div class="xk-verified">

                        ✔ Verified Purchase

                    </div>`

                    :``}

                </div>

            </div>

        </div>

        <div class="xk-stars">

            ${generateStars(review.rating)}

        </div>

        <div class="xk-text">

            ${review.review}

        </div>

        <div class="xk-footer">

            <div
                class="xk-likes"
                data-index="${index}">

                👍

                <span>

                    ${review.likes || 0}

                </span>

            </div>

        </div>

    </div>

</div>

`);

        });

    }

    renderCards();
    /*==================================================
  XKIND CUSTOMER REVIEWS
  PART 2 - Rating Summary + Like Button
==================================================*/

    /* ---------- Rating Summary ---------- */

    const avgRating=document.querySelector(".xk-average-rating");

    const totalReviews=document.querySelector(".xk-total-review");

    if(avgRating){

        let total=0;

        reviews.forEach(function(item){

            total+=Number(item.rating);

        });

        avgRating.innerHTML=(total/reviews.length).toFixed(1);

    }

    if(totalReviews){

totalReviews.innerHTML=

`Based on ${data.reviews_count} Customer Reviews`;

}
    /* ---------- Like Button ---------- */

    const likeButtons=document.querySelectorAll(".xk-likes");

    likeButtons.forEach(function(button){

        const index=button.dataset.index;

        const key="xk_review_like_"+index;

        const countElement=button.querySelector("span");

        let count=parseInt(countElement.innerHTML);

        if(localStorage.getItem(key)){

            button.classList.add("active");

        }

        button.addEventListener("click",function(){

            if(localStorage.getItem(key)) return;

            count++;

            countElement.innerHTML=count;

            localStorage.setItem(key,"1");

            button.classList.add("active");

        });

    });

    /* ---------- Arrow Buttons ---------- */

    const prev=document.querySelector(".xk-prev");

    const next=document.querySelector(".xk-next");

    let scrollAmount=278;

    function updateScrollAmount(){

        if(window.innerWidth<480){

            scrollAmount=202;

        }

        else if(window.innerWidth<768){

            scrollAmount=218;

        }

        else if(window.innerWidth<1024){

            scrollAmount=248;

        }

        else{

            scrollAmount=278;

        }

    }

    updateScrollAmount();

    window.addEventListener("resize",updateScrollAmount);

    if(prev){

        prev.addEventListener("click",function(){

            container.scrollBy({

                left:-scrollAmount,

                behavior:"smooth"

            });

        });

    }

    if(next){

        next.addEventListener("click",function(){

            container.scrollBy({

                left:scrollAmount,

                behavior:"smooth"

            });

        });

    }
    /*==================================================
  XKIND CUSTOMER REVIEWS
  PART 3 - Pagination + Touch Swipe + Image Popup
==================================================*/

    /* ---------- Pagination ---------- */

    const pagination=document.getElementById("xk-review-pagination");

    function createPagination(){

        if(!pagination) return;

        pagination.innerHTML="";

        reviews.forEach(function(item,index){

            const dot=document.createElement("span");

            dot.className="xk-dot";

            if(index===0){

                dot.classList.add("active");

            }

            dot.dataset.index=index;

            pagination.appendChild(dot);

        });

    }

    createPagination();

    function updatePagination(){

        const active=Math.round(container.scrollLeft/scrollAmount);

        document.querySelectorAll(".xk-dot").forEach(function(dot){

            dot.classList.remove("active");

        });

        const current=document.querySelector(

            '.xk-dot[data-index="'+active+'"]'

        );

        if(current){

            current.classList.add("active");

        }

    }

    container.addEventListener("scroll",updatePagination);

    document.querySelectorAll(".xk-dot").forEach(function(dot){

        dot.addEventListener("click",function(){

            container.scrollTo({

                left:Number(this.dataset.index)*scrollAmount,

                behavior:"smooth"

            });

        });

    });

    /* ---------- Touch Swipe ---------- */

    let startX=0;

    let endX=0;

    container.addEventListener("touchstart",function(e){

        startX=e.touches[0].clientX;

    });

    container.addEventListener("touchmove",function(e){

        endX=e.touches[0].clientX;

    });

    container.addEventListener("touchend",function(){

        const diff=startX-endX;

        if(Math.abs(diff)<40) return;

        if(diff>0){

            container.scrollBy({

                left:scrollAmount,

                behavior:"smooth"

            });

        }else{

            container.scrollBy({

                left:-scrollAmount,

                behavior:"smooth"

            });

        }

    });

    /* ---------- Image Popup ---------- */

    document.addEventListener("click",function(e){

        const img=e.target.closest(".xk-review-image img");

        if(!img) return;

        const popup=document.createElement("div");

        popup.className="xk-lightbox";

        popup.innerHTML=`

            <img src="${img.src}" alt="Review">

        `;

        document.body.appendChild(popup);

        document.body.style.overflow="hidden";

        popup.addEventListener("click",function(){

            popup.remove();

            document.body.style.overflow="";

        });

    });
    /*==================================================
  XKIND CUSTOMER REVIEWS
  PART 4 - Auto Slider + Keyboard + Empty State
==================================================*/

    /* ---------- Auto Slider ---------- */

    let autoSlide;

    function startAutoSlide(){

        stopAutoSlide();

        autoSlide=setInterval(function(){

            const maxScroll=

            container.scrollWidth-container.clientWidth;

            if(container.scrollLeft>=maxScroll-5){

                container.scrollTo({

                    left:0,

                    behavior:"smooth"

                });

            }else{

                container.scrollBy({

                    left:scrollAmount,

                    behavior:"smooth"

                });

            }

        },4500);

    }

    function stopAutoSlide(){

        clearInterval(autoSlide);

    }

    startAutoSlide();

    container.addEventListener("mouseenter",stopAutoSlide);

    container.addEventListener("mouseleave",startAutoSlide);

    container.addEventListener("touchstart",stopAutoSlide);

    container.addEventListener("touchend",startAutoSlide);

    /* ---------- Keyboard ---------- */

    document.addEventListener("keydown",function(e){

        if(e.key==="ArrowRight"){

            container.scrollBy({

                left:scrollAmount,

                behavior:"smooth"

            });

        }

        if(e.key==="ArrowLeft"){

            container.scrollBy({

                left:-scrollAmount,

                behavior:"smooth"

            });

        }

    });

    /* ---------- Resize ---------- */

    window.addEventListener("resize",function(){

        updateScrollAmount();

        updatePagination();

    });

    /* ---------- Empty Reviews ---------- */

    if(reviews.length===0){

        container.innerHTML=`

        <div style="

            width:100%;

            padding:70px 20px;

            text-align:center;

            color:#666;

        ">

            <h3 style="margin-bottom:10px;">

                No Reviews Yet

            </h3>

            <p>

                Be the first customer to review this product.

            </p>

        </div>

        `;

    }

    /* ---------- Console ---------- */

    console.log(

        "XKIND Customer Reviews Loaded",

        reviews.length

    );

});